import { RegisteredItem } from '../registered-item/registered-item.interface';

export type RegistrationResponse = RegisteredItem[];
